"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.SYNC_SOURCE, (table)=>{
        table.string('base_id', 20);
        table.foreign('base_id').references(`${_globals.MetaTableOldV2.BASES}.id`);
    });
    await knex.schema.alterTable(_globals.MetaTableOldV2.BASES, (table)=>{
        table.boolean('enabled').defaultTo(true);
        table.float('order');
    });
    await knex.schema.alterTable(_globals.MetaTable.AUDIT, (table)=>{
        table.dropForeign('base_id');
    });
};
const down = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.SYNC_SOURCE, (table)=>{
        table.dropColumn('base_id');
    });
    await knex.schema.alterTable(_globals.MetaTableOldV2.BASES, (table)=>{
        table.dropColumn('enabled');
        table.dropColumn('order');
    });
    await knex.schema.alterTable(_globals.MetaTable.AUDIT, (table)=>{
        table.foreign('base_id').references(`${_globals.MetaTableOldV2.BASES}.id`);
    });
};
 /**
 * @copyright Copyright (c) 2022, Xgene Cloud Ltd
 *
 * @author Mert Ersoy <mert@nocodb.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */ 